<div class="flex">
  <p-floatLabel>
    <p-dropdown
      id="seletorConexao"
      [options]="conexoes"
      [(ngModel)]="conexaoAtual"
      optionLabel="nome"
      optionValue="id"
      [placeholder]="placeholder"
      [disabled]="disabled || loading"
      [style]="{'width':'100%', 'min-width':'200px'}"
      appendTo="body"
      (onChange)="onConexaoChange($event)"
      emptyMessage="Nenhuma conexão disponível">
      <ng-template pTemplate="selectedItem" let-item>
        <div *ngIf="item">
          <span>{{ item.nome }}</span>
          <span class="text-xs text-gray-500 ml-2">({{ item.ambiente }})</span>
        </div>
      </ng-template>
      <ng-template pTemplate="item" let-conexao>
        <div class="flex align-items-center">
          <div>
            <div>{{ conexao.nome }}</div>
            <div class="text-xs text-gray-500">{{ conexao.ambiente }}</div>
          </div>
          <p-tag *ngIf="conexao.padrao" value="Padrão" severity="success" class="ml-2" />
        </div>
      </ng-template>
    </p-dropdown>
    <label for="seletorConexao">{{ label }}</label>
  </p-floatLabel>
</div>
